import { render, staticRenderFns } from "./BpExpensesTable.vue?vue&type=template&id=4c325475"
import script from "./BpExpensesTable.vue?vue&type=script&lang=ts"
export * from "./BpExpensesTable.vue?vue&type=script&lang=ts"
import style0 from "./BpExpensesTable.vue?vue&type=style&index=0&id=4c325475&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports